import { cn } from "../../../lib/utils";

const DetailsSectionCard = ({
  title,
  link,
  children,
  className,
  contentClassName,
}: {
  title: string;
  link?: string;
  children: any;
  className?: string;
  contentClassName?: string;
}) => {
  return (
    <div
      className={cn(
        "p-5 rounded-xl bg-[#FFEFE5] border border-[#F8D2BF]",
        className
      )}
    >
      <div className="flex justify-between mb-3 border-b-primary border-b pb-1 w-full">
        <h3 className="font-semibold text-lg text-primary ">{title}</h3>
        {link && <span className="text-primary cursor-pointer">{link}</span>}
      </div>
      <div className={cn("grid grid-cols-1 md:grid-cols-2 gap-4", contentClassName)}>{children}</div>
    </div>
  );
};

export default DetailsSectionCard;
